
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8a8 8 0 018-8h24a8 8 0 018 8v24a8 8 0 01-8 8H8a8 8 0 01-8-8V8z","fill":"#FFF3D8"}}),_c('path',{attrs:{"d":"M20 10c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm-5 8.5a1.5 1.5 0 113.001.001A1.5 1.5 0 0115 18.5zm9 6.5h-8.026v-2H24v2zm-.507-5.014a1.494 1.494 0 11.001-2.987 1.494 1.494 0 01-.001 2.987z","fill":"#FFA23F"}})])
          )
        }
      }
    